export class LoginModel {
    UserName: string;
    Password: string;
}
export class RegisterModel {
    FirstName: string;
    LastName: string;
    Email: string;
    Password: string;
}
export class ConfirmAccountModel{
    Token: string;
}
export class ResendConformationModel{
    Email: string;
}